if (!window.customElements.get('scroll-slider')) {
  class ScrollSlider extends HTMLElement {
    connectedCallback() {
      this._scroll = this.querySelector('[data-scroll]');
      this._thumb = this.querySelector('[data-thumb]');
      if (!this._scroll || !this._thumb) return;
      this._update = this._update.bind(this);
      this._scroll.addEventListener('scroll', this._update, { passive: true });
      window.addEventListener('resize', this._update);
      requestAnimationFrame(this._update);
    }
    disconnectedCallback() {
      if (this._scroll) this._scroll.removeEventListener('scroll', this._update);
      window.removeEventListener('resize', this._update);
    }
    _update() {
      const scroll = this._scroll;
      const thumb = this._thumb;
      if (!scroll || !thumb) return;
      const track = thumb.parentElement;
      const max = scroll.scrollWidth - scroll.clientWidth;
      if (max <= 1) {
        track.style.visibility = 'hidden';
        return;
      }
      track.style.visibility = '';
      const pct = scroll.scrollLeft / max;
      const trackWidth = track.clientWidth;
      const thumbWidth = Math.max(40, (scroll.clientWidth / scroll.scrollWidth) * trackWidth);
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + (pct * (trackWidth - thumbWidth)) + 'px)';
    }
  }
  customElements.define('scroll-slider', ScrollSlider);
}
